/**
 * 邀请人关系
 */
export const INVITE_RELATIONS_MAP = {
  SAME_LEADER: {
    code: 0,
    label: '相同上级'
  },
  NO_SAME_LEADER: {
    code: 1,
    label: '不同上级'
  },
  DIRECTLY_SUBORDINATE: {
    code: 2,
    label: '直属下级'
  },
  DIRECTLY_LEADER: {
    code: 3,
    label: '直属上级'
  }
}

/**
 * 邀请人来源
 */
export const INVITE_SOURCE_MAP = {
  DEFAULT_INVITATION: {
    code: 0,
    label: '默认邀请'
  },
  MY_INVITATION: {
    code: 2,
    label: '自己邀请'
  },
  LEADER_INVITATION: {
    code: 3,
    label: '上级邀请'
  },
  OTHER_USER_INVITATION: {
    code: 4,
    label: '其他人邀请'
  }
}
/**
 * 邀请人关系筛选
 */
export const INVITE_RELATIONS_OPTIONS = [
  {
    label: INVITE_RELATIONS_MAP.SAME_LEADER.label,
    value: INVITE_RELATIONS_MAP.SAME_LEADER.code
  },
  {
    label: INVITE_RELATIONS_MAP.NO_SAME_LEADER.label,
    value: INVITE_RELATIONS_MAP.NO_SAME_LEADER.code
  },
  {
    label: INVITE_RELATIONS_MAP.DIRECTLY_SUBORDINATE.label,
    value: INVITE_RELATIONS_MAP.DIRECTLY_SUBORDINATE.code
  },
  {
    label: INVITE_RELATIONS_MAP.DIRECTLY_LEADER.label,
    value: INVITE_RELATIONS_MAP.DIRECTLY_LEADER.code
  }
]
